import React, { useState } from "react";
import Common_Report_Offcanvas from "../../../../common_report_offcanvas/Common_Report_Offcanvas";
import Environmental_Report_Filter from "./environmental_report_filter/Environmental_Report_Filter";
import Environmental_Report_Table from "./environmental_report_table/Environmental_Report_Table";


const Environmental_Report = () => {
  const [show, setShow] = useState(false);

  return (
    <section className="Sample_Report">
      <div className="Sample_Report_Filter_div">
        <Environmental_Report_Filter setShow={setShow} />
      </div>

      <div className="report_table_div">
        <Environmental_Report_Table />
      </div>

      <Common_Report_Offcanvas
        title={"Environmental Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Environmental_Report;
